import { QueryClient } from "@tanstack/react-query";

export type PlatformContentListItem = {
  _id: string;
  programId?: string | null;
  programName?: string | null;
  programImageS3Key?: string | null;
  programImageUpdatedAt?: string | null;
  brands?: Array<{ brandKey: string; name: string; logo: string | null }>;
  [key: string]: unknown;
};

export type PlatformContentListData = {
  items: PlatformContentListItem[];
  total?: number;
  page?: number;
  limit?: number;
  hasLivestreamData?: boolean;
};

function contentIdsMatch(a: unknown, b: string): boolean {
  return a != null && String(a) === b;
}

/**
 * Patch the matching content row across all cached `platform-content` list queries
 * so card chips update immediately after program/brand edits.
 */
export function patchPlatformContentItems(
  queryClient: QueryClient,
  contentId: string,
  patch: (
    item: PlatformContentListItem,
  ) => PlatformContentListItem | null | undefined,
): void {
  queryClient.setQueriesData<PlatformContentListData>(
    { queryKey: ["platform-content"] },
    (data) => {
      if (!data?.items?.length) return data;
      let changed = false;
      const items = data.items.map((item) => {
        if (!contentIdsMatch(item._id, contentId)) return item;
        const next = patch(item);
        if (!next || next === item) return item;
        changed = true;
        return next;
      });
      return changed ? { ...data, items } : data;
    },
  );
}
